import $ from 'jquery';

// 전역 변수 선언
document.addEventListener('DOMContentLoaded', () => {
    // get 파라미터
    const urlParams = new URLSearchParams(window.location.search);
    const mk = (parseInt(urlParams.get('xc')) > 0 && parseInt(urlParams.get('yc')) > 0) ? 1 : 0;
    var TK_ = {
        'x': parseFloat(urlParams.get('yc')) || 0,
        'y': parseFloat(urlParams.get('xc')) || 0,
        'mk': mk,
        'addr': urlParams.get('address') || '',
        'sangho': urlParams.get('sangho') || ''
    };

    var mapContainer = document.getElementById('map'),
        mapOption = {
            center: new kakao.maps.LatLng(33.450701, 126.570667),
            level: 3
        };
    window.map = new kakao.maps.Map(mapContainer, mapOption);
    var geocoder = new kakao.maps.services.Geocoder();
    if (TK_['x'] > 0 && TK_['y'] > 0) {
        if (TK_['mk'] == 1) {
            addmark(TK_['x'], TK_['y'], TK_['sangho']);
        }
    } else {
        geocoder.addressSearch(TK_['addr'], (result, status) => a2c(result, status, map, TK_));
    }

    $(`#zoomIn`).on('click', function () {
        zoomIn(window.map);
    });
    $(`#zoomOut`).on('click', function () {
        zoomOut(window.map);
    });

    $(`#btnRoadmap`).on('click', function () {
        setMapType('roadmap', window.map);
    });
    $(`#btnSkyview`).on('click', function () {
        setMapType('skyview', window.map);
    });
});

function setMapType(maptype, map) {
    var roadmapControl = document.getElementById('btnRoadmap');
    var skyviewControl = document.getElementById('btnSkyview');
    if (maptype === 'roadmap') {
        map.setMapTypeId(kakao.maps.MapTypeId.ROADMAP);
        roadmapControl.className = 'selected_btn';
        skyviewControl.className = 'btn';
    } else {
        map.setMapTypeId(kakao.maps.MapTypeId.HYBRID);
        skyviewControl.className = 'selected_btn';
        roadmapControl.className = 'btn';
    }
}

function zoomIn(map) {
    window.map.setLevel(map.getLevel() - 1);
}

function zoomOut(map) {
    window.map.setLevel(map.getLevel() + 1);
}

function a2c(result, status, map, TK_) {
    if (status === kakao.maps.services.Status.OK) {
        addmark(map, result[0].y, result[0].x, TK_['sangho']);
    } else {
        alert("주소를 좌표로 변환 할 수 없습니다.");
    }
};

function addmark(x, y, sangho) {
    var xy = new kakao.maps.LatLng(x, y);
    window.map.setCenter(xy);
    var marker = new kakao.maps.Marker({
        position: xy
    });
    marker.setMap(window.map);
    var iwContent = '<div style="padding:5px;">' + sangho + '</div>',
        iwPosition = xy,
        iwRemoveable = true;
    var infowindow = new kakao.maps.InfoWindow({
        map: window.map,
        position: xy,
        content: iwContent,
        removable: iwRemoveable
    });
    infowindow.open(window.map, marker);
    infowindow.close();
    kakao.maps.event.addListener(marker, 'mouseover', function () {
        infowindow.open(window.map, marker);
    });
    kakao.maps.event.addListener(marker, 'mouseout', function () {
        infowindow.close();
    });
}

function resizing() {
    var clientH = jQ(window).height();
    var clientW = jQ(window).width();
    jQ("#map").css({
        "height": clientH + "px"
    });
    jQ(".map_wrap").css({
        "height": clientH + "px"
    });
}